import { useCallback, useEffect, useState } from 'react';
import { DEFAULT_SCROLL_OFFSET } from '../constants/app';

const useIsScrollingUp = () => {
  const [y, setY] = useState(0);
  const [isScrollingUp, setIsScrollingUp] = useState(false);

  const handleNavigation = useCallback(
    (e) => {
      const window = e.currentTarget;

      if (window.scrollY <= DEFAULT_SCROLL_OFFSET) {
        setIsScrollingUp(false);
      }

      if (window.scrollY > DEFAULT_SCROLL_OFFSET && y > window.scrollY + 10 && !isScrollingUp) {
        setIsScrollingUp(true);
      } else if (window.scrollY > DEFAULT_SCROLL_OFFSET && y < window.scrollY && isScrollingUp) {
        setIsScrollingUp(false);
      }
      setY(window.scrollY);
    },
    [y],
  );

  useEffect(() => {
    setY(window.scrollY);
    window.addEventListener('scroll', handleNavigation);

    return () => {
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [handleNavigation]);

  return isScrollingUp;
};

export default useIsScrollingUp;
